import { useSelector } from 'react-redux'
import { useJackpotContributions } from '@hooks/queries/useJackpot'
import { useJackpotNavigation } from '@hooks/jackpot/useJackpotNavigation'
import { JACKPOT_TABLE_HEADERS, JACKPOT_MESSAGES } from '@constants/jackpotConstants'
import JackpotTable from './JackpotTable'

// Per-bet contribution breakdown for one jackpot (used for both Active and
// History — same query, just scoped to whichever jackpotId is open). Clicking
// a row's ticket count drills into that bet's individual ticket ids.
const JackpotMyContributionsTable = ({ jackpotId }) => {
  const currencyCode = useSelector((state) => state.wallet.displayCurrencyCode)
  const { data, isPending, isError } = useJackpotContributions({ jackpotId })
  const { onViewBetTickets } = useJackpotNavigation()
  const rows = data?.rows ?? []

  return (
    <JackpotTable
      headers={JACKPOT_TABLE_HEADERS.MY_CONTRIBUTIONS}
      rows={rows}
      isPending={isPending}
      isError={isError}
      emptyMessage={JACKPOT_MESSAGES.NO_MY_CONTRIBUTIONS}
      currencyCode={currencyCode}
      renderRow={(row, index) => (
        <div key={row.betId ?? index} className="standard-normal-jackpot-table-row">
          <div className="standard-normal-jackpot-table-cell standard-normal-jackpot-table-cell-datetime">
            <span>{row.date}</span>
            <span>{row.time}</span>
          </div>
          <div className="standard-normal-jackpot-table-cell">{row.type}</div>
          <div className="standard-normal-jackpot-table-cell">{row.stake}</div>
          <div className="standard-normal-jackpot-table-cell">{row.contribution}</div>
          <div
            className="standard-normal-jackpot-table-cell standard-normal-jackpot-table-cell-link"
            onClick={() => onViewBetTickets(rows, row.betId)}
          >
            {row.tickets}
          </div>
        </div>
      )}
    />
  )
}

export default JackpotMyContributionsTable
